import type { Breakpoint, Theme } from '@mui/material';
import { useMediaQuery } from '@mui/material';

import type { UseBreakpointsReturnValue } from './useBreakpoints.types';

export const useBreakpoints = (theme: Theme): UseBreakpointsReturnValue => {
  const isLessThan3xs = useMediaQuery(
    theme.breakpoints.down('3xs' as Breakpoint)
  );

  const isMoreThan3xs = useMediaQuery(
    theme.breakpoints.up('3xs' as Breakpoint)
  );

  const isMoreThan2xs = useMediaQuery(
    theme.breakpoints.up('2xs' as Breakpoint)
  );

  const isLessThanXs = useMediaQuery(theme.breakpoints.down('xs'));

  return { isLessThan3xs, isLessThanXs, isMoreThan2xs, isMoreThan3xs };
};
